import React from 'react';
import Page from '../../layout/Page';
import PlateReadAwards from '../plateReads/PlateReadAwards';

const PlateReadAwardsPage = () => (
    <Page title='License Plate' icon='coins'>
        <PlateReadAwards />
    </Page>
);

export default PlateReadAwardsPage;
